import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
export function encodeQueue(packet, writer = new BinaryWriter(8)) {
    writer.u8(ServerOp.Queue).u16(packet.position).u16(packet.total);
    return writer;
}
export function decodeQueue(reader) {
    return { position: reader.u16(), total: reader.u16() };
}
//# sourceMappingURL=queue.js.map